import React, { useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Grid2,
  Button,
  Typography,
  Divider,
  useMediaQuery,
} from "@mui/material";
import { SearchForm } from "../../layouts/searchpage/SearchForm";
import SearchInfoCard from "../../layouts/searchpage/SearchInfoCard";
import { CategoryButtons } from "../../layouts/searchpage/CategoryButtons";
import { categories } from "../../constants/searchpageTexts";
import { processingTypes } from "../../constants/searchpageTexts";
import ContentLayout from "../../layouts/ContentLayout";

import { useSearchQuery } from "../../hooks/useSearch/useSearchQuery";
import { isDebug } from "../../utils";

const SearchPage2 = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width:600px)");
  const currentYear = new Date().getFullYear();
  const [filters, setFilters] = React.useState({
    // 처음 값 전체로 지정함
    // categoryKey: "ProductionYear",
    // categoryValue: currentYear,
  });
  const isAllCategory = filters.categoryKey === undefined;

  const searchTextRef = useRef("");
  const [searchParams, setSearchParams] = useSearchParams();
  const keyword = searchParams.get("q") || "";

  const {
    data: greenBeansData,
    error,
    refetch,
  } = useSearchQuery(
    {
      keyword,
      categoryKey: isAllCategory
        ? undefined
        : filters.categoryKey || "ProductionYear",
      categoryValue: isAllCategory
        ? undefined
        : filters.categoryValue || currentYear,
      pageType: "searchPage",
    },
    {
      queryKey: ["green-beans", { keyword, ...filters }],
      enabled: true,
    }
  );
  const [listData, setListData] = React.useState({
    count: 0,
    record: [],
    displaySize: isMobile ? 4 : 12,
  });

  const handleSearch = (newKeyword) => {
    if (isDebug()) console.log("handleSearch", newKeyword);
    if (keyword === newKeyword) {
      refetch();
    }
    setSearchParams({ q: newKeyword });
  };

  // 사용 안 함
  // const yearsCategories = {
  //   [`${currentYear}년`]: {
  //     key: "ProductionYear",
  //     value: `${currentYear}`,
  //   },
  // };
  const combinedCategories = {
    전체: { key: "전체", value: "", name: "ALL" },
    // ...yearsCategories,
    ...categories,
  };

  const initialValue = Object.keys(combinedCategories)[0];
  const [selectedCategory, setSelectedCategory] = React.useState(initialValue);

  const handleCategoryChange = (key, value) => {
    const newKeyword = searchTextRef.current;
    if (isDebug()) console.log("카테고리 변경:", key, value);
    if (key === "전체") {
      setFilters({});
      setSelectedCategory(key);
      setSearchParams(newKeyword ? { q: newKeyword } : {});

      if (selectedCategory === key) {
        refetch();
      }
    } else {
      setFilters({ categoryKey: key, categoryValue: value });
      setSelectedCategory(key);
      const params = {
        q: newKeyword,
        ...(value !== undefined ? { [key]: value } : {}),
      };
      setSearchParams(params);
      if (filters.categoryValue === value && keyword === newKeyword) {
        refetch();
      }
    }
    setListData({ count: 0, record: [], displaySize: isMobile ? 4 : 12 });
  };

  const handleDetailClick = (coffee_key_id) => {
    navigate(`/detail/${coffee_key_id}`);
  };

  const LoadData = () => {
    let arr = [];
    let startValue =
      listData?.record?.length < 1 ? 0 : listData?.record?.length;
    if (startValue > 0) arr = listData.record;

    if (
      greenBeansData &&
      greenBeansData.length > 0 &&
      listData.record.length <= greenBeansData.length
    ) {
      for (let i = startValue; i < startValue + listData.displaySize; i++) {
        if (greenBeansData.length === i) break;
        arr.push(greenBeansData[i]);
      }
      setListData({ ...listData, count: arr.length, record: arr });
    }
  };

  React.useEffect(() => {
    document.title = "BWOB - " + t("nav.search");

    setListData({ count: 0, record: [], displaySize: isMobile ? 4 : 12 });
    LoadData();
  }, [greenBeansData, error, filters, selectedCategory]);

  return (
    <ContentLayout pageTitle={t("nav.search")} pageDescription={null}>
      <SearchForm
        onChangeText={(text) => {
          searchTextRef.current = text;
        }}
        onSearch={handleSearch}
      />
      <CategoryButtons
        selected={selectedCategory}
        combinedCategories={combinedCategories}
        onCategoryChange={handleCategoryChange}
        setSelectedCategory={setSelectedCategory}
      />
      <Divider sx={{ my: 1, m: 2, borderStyle: "dotted" }} />
      <Typography variant="h6">
        {t("searchfield.searchcount")} :{" "}
        {greenBeansData?.length < 0 ? 0 : greenBeansData?.length}
      </Typography>
      <Grid2 container spacing={4}>
        <CoffeeCardList
          listData={listData.record}
          handleDetailClick={handleDetailClick}
        />
      </Grid2>
      &nbsp;
      <Divider sx={{ my: 2, m: 2, borderStyle: "dotted" }} />
      <Button onClick={LoadData} fullWidth>
        <Typography variant="h6">
          {t("button.more")}{" "}
          {i18n.language.toLowerCase() === "ko" ? "(More)" : null}
        </Typography>
      </Button>
      &nbsp;
    </ContentLayout>
  );
};

export const CoffeeCardList = (props) => {
  const { listData, handleDetailClick } = props;

  return (
    <>
      {listData && listData.length > 0
        ? listData.map((coffee, index) => (
            <SearchInfoCard
              index={index}
              handleDetailClick={() => handleDetailClick(coffee.CoffeeKey)}
              key={coffee.CoffeeKey + index}
              dataImageUrl={
                coffee.ImageUrl ||
                "https://media.istockphoto.com/id/2164909312/ko/%EC%82%AC%EC%A7%84/%EC%BB%A4%ED%94%BC-%EC%9B%90%EB%91%90-%EB%A1%9C%EC%8A%A4%ED%8C%85-%EC%A0%9C%ED%92%88-%EC%88%98%EC%B6%9C-%EB%98%90%EB%8A%94-%ED%92%88%EC%A7%88-%EB%B3%B4%EC%A6%9D%EC%9D%84-%EC%9C%84%ED%95%9C-%EC%84%B1%EB%B6%84%EC%9D%B4-%EC%9E%88%EB%8A%94-%EA%B8%B0%EA%B3%84-%EB%B0%8F-%EA%B3%B5%EC%9E%A5-%EB%B9%84%EC%96%B4-%EC%9E%88%EB%8A%94-%ED%8F%89%EB%A9%B4%EB%8F%84-%EB%B0%8F-%ED%94%84%EB%A6%AC%EB%AF%B8%EC%97%84-%EC%97%90%EC%8A%A4%ED%94%84%EB%A0%88%EC%86%8C-%EC%B9%B4%ED%8E%98%EC%9D%B8-%EB%98%90%EB%8A%94-%EC%8B%A0%EC%84%A0%ED%95%9C-%EB%B8%94%EB%A0%8C%EB%93%9C%EB%A5%BC-%EC%9C%84%ED%95%9C-%EC%9E%A5%EB%B9%84%EB%A1%9C-%EC%A0%9C%EC%A1%B0.jpg?s=1024x1024&w=is&k=20&c=U4mS4xAItRN1ml8zvDRJ1becEN0UEoA0KbnVLqENKdA="
              }
              dataTitle={coffee.CoffeeName}
              dataBeanVariety={coffee?.BeanVariety?.split(", ")}
              dataProductionCountry={coffee.CountryNameEng}
              dataCompanyName={coffee.Company}
              dataFarmName={coffee.Farm}
              dataProductionYear={coffee.ProductionYear}
              dataProcessingMethod={processingTypes[coffee.ProcessingCode]}
            />
          ))
        : null}
    </>
  );
};

export default SearchPage2;
